import React from 'react';
import { motion } from 'framer-motion';
import { assets, salon, whatsappHref } from '../data/content';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowIcon, PinIcon, StarIcon } from './icons/GoldIcons';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative isolate min-h-[calc(100vh-7rem)] w-full overflow-hidden bg-ink-900" data-id="element-116" data-mp="4n9wadwh9812">
      <img src={assets.banner} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-[72%_center]" data-id="element-117" data-mp="127edzcmxdncx" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#070605_8%,rgba(7,6,5,0.92)_36%,rgba(7,6,5,0.35)_62%,rgba(7,6,5,0.15)_100%)]" aria-hidden="true" data-id="element-118" data-mp="sarvuvlzhael" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-[linear-gradient(180deg,rgba(7,6,5,0)_0%,#070605_92%)]" aria-hidden="true" data-id="element-119" data-mp="neauv0tor1k3" />

      <div className="relative mx-auto flex min-h-[calc(100vh-7rem)] max-w-7xl flex-col justify-center px-5 pb-12 pt-[15vh] sm:px-8" data-id="element-120" data-mp="381xmt2oj9aca">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease
      }} className="max-w-2xl" data-id="element-121" data-mp="3j9tymsm91cin">
          

          <p className="mt-2 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-gold-muted" data-id="element-122" data-mp="39cflp2zjb5v3">
            <span className="h-px w-8 bg-gold-deep" aria-hidden="true" data-id="element-123" data-mp="3eb8zyxmnb0wb" />
            {t.hero.location}
          </p>

          <h1 className="gold-shine mt-6 font-display text-4xl font-semibold leading-[1.08] sm:text-5xl lg:text-[3.6rem]" data-id="element-124" data-mp="358hlsq2dxr0z">
            {t.hero.title}
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-neutral-300" data-id="element-125" data-mp="2qlod43ndfjhr">
            {t.hero.subtitle}
          </p>

          <div className="mt-[5.5rem] flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-126" data-mp="2hj5drtisnp09">
            <a href={whatsappHref(t.whatsappMessage)} target="_blank" rel="noreferrer" className="btn-gold-shine inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.16em]" data-id="element-127" data-mp="2hlj983hdz38c">
              {t.ctaShort}
              <ArrowIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-128" data-mp="n98crlqgh1mu" />
            </a>
            <a href="#servicios" className="inline-flex items-center justify-center gap-3 rounded-full border border-gold-deep/50 px-8 py-4 text-[13px] font-semibold uppercase tracking-[0.22em] text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory" data-id="element-129" data-mp="icrp0sn64paa">
              {t.hero.secondaryCta}
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-130" data-mp="112g5xhu6q56n">
            <div className="flex items-center gap-3" data-id="element-131" data-mp="114kjyslsskkn">
              <div className="flex text-gold-bright" aria-hidden="true" data-id="element-132" data-mp="x0cq6h0hgefk">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4" data-id="element-133" data-mp="3ltqbtahzursg" />)}
              </div>
              <span className="text-sm text-neutral-400" data-id="element-134" data-mp="3hr3sjxze2f6v">
                <span className="text-gold-ivory" data-id="element-135" data-mp="3htq0vzu3syq5">{salon.rating}</span> · {t.hero.ratingNote}
              </span>
            </div>
            <p className="flex items-center gap-2 text-sm text-neutral-400" data-id="element-136" data-mp="21aehzejeah9k">
              <PinIcon className="h-4 w-4 text-gold-muted" strokeWidth={1.5} data-id="element-137" data-mp="269zhpr6e2tnc" />
              {salon.addressShort}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}